import React from 'react';
import {
  Container, Row, Col,
  //Button
} from 'reactstrap';
import MenuNew from '../MenuNew';
import NavbarDrop from '../HomePageNew/NavbarDrop';

class PlansCompany extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    };

    this.styles = {

    };
  }



  render() {
    return (
      <div>
        <div>
          <MenuNew />
        </div>
        <NavbarDrop/>
        {/*************************** PLANOS **************************/}
        <Container id="purchase_plan_company">
          <div className="plan_1_company">
            <Row style={{margin:0}}>
              <Col style={{margin:0, padding:0}} xs="12" sm="12" md="6" lg="6">
                <div className="div1">
                  <p className="text_company1">PARA SUA EMPRESA</p>
                  <hr className="hr_tam"/>
                  <div className="text_company2">CUIDAR DA</div>
                  <div className="text_company2" style={{marginTop:-25}}>SAÚDE É UM</div>
                  <div className="text_company2" style={{marginTop:-25}}>BOM NEGÓCIO</div>
                </div>
              </Col>
              <Col style={{margin:0, padding:0}} xs="12" sm="12" md="6" lg="6">
                <iframe
                  src="https://planodentalcenter.com.br/assets/docs/form_crm7.html"
                  style={{width: 395, height: 410, overflow: 'hidden', border: 0, marginTop: 60}}
                >{''}</iframe>
                {/* <div className="div1">
                  <div className="text_company_col1">R$24,90</div>
                  <div className="text_company_col2" style={{marginTop:-15}}>VALOR UNITÁRIO / POR MÊS</div>
                  <div className="text_company_col2"style={{marginTop:-5}}>PARA EMPRESAS COM 03 A 29 FUNCIONÁRIOS</div>
                </div> */}
              </Col>
            </Row>
            <div className="div2">
              {/* <Row style={{textAlign:'center'}}>
                <Col style={{height:54}}>
                  <Button className="button_company">CONSULTAR VALORES</Button>
                </Col>
                <Col className="margin_button_company">
                  <Button className="button_company">CONTRATAR AGORA</Button>
                </Col>
              </Row> */}
              <p className="text_register">REGISTRO DO PRODUTO NA ANS: 471.616/14-7</p>
            </div>
          </div>
        </Container>
        <Container >
          <hr className="hr_style_company"/>
          <p className="title_company">CONHEÇA OS SERVIÇOS</p>
          <div id="find_yellow_company">&nbsp;</div>
          <div className="every_icons_company">
            {/* <Row style={{marginTop:60}}> */}
            <Row>
              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon1_company">{''}</div>
                <p className="text_icon_company">CONSULTAS</p>
              </Col>
              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon2_company">{''}</div>
                <p className="text_icon_company">URGÊNCIA E<br/>EMERGÊNCIA</p>
              </Col>
              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon3_company">{''}</div>
                <p className="text_icon_company">LIMPEZA, PREVENÇÃO E<br/>APLICAÇÃO DE FLÚOR</p>
              </Col>
            {/* </Row>
            <Row style={{marginTop:60}}> */}
              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon4_company">{''}</div>
                <p className="text_icon_company">TRATAMENTO DE <br/>GENGIVA<br/>(PERIODONTIA)</p>
              </Col>
              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon5_company">{''}</div>
                <p className="text_icon_company">TRATAMENTO PARA<br/>CRIANÇAS<br/>(ODONTOPEDIATRIA)</p>
              </Col>
              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon6_company">{''}</div>
                <p className="text_icon_company">TRATAMENTO DE CANAL<br/>(ENDODONTIA)</p>
              </Col>

              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon7_company">{''}</div>
                <p className="text_icon_company">CIRURGIAS E<br/> EXTRAÇÕES</p>
              </Col>
              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon8_company">{''}</div>
                <p className="text_icon_company">RESTAURAÇÕES<br/>(DENTÍSTICA)</p>
              </Col>
              <Col style={{marginTop:60}} xs="12" sm="6" md="4" lg="4" xl="4">
                <div className="icon9_company">{''}</div>
                <p className="text_icon_company">COROAS (CONFORME<br/>RN 211)</p>
              </Col>
            </Row>
          </div>
          <hr style={{marginBottom:80, marginTop:80}} className="hr_style_company"/>
        </Container>
        <Container style={{marginBottom:60}}>
          <p className="title_company">CARÊNCIAS</p>
          <div id="find_yellow_company2">&nbsp;</div>
          <table className="table_company">
            <thead className="tr_company">
                <tr>
                  <th className="col_table left_radius">SERVIÇOS</th>
                  <th>DE 03 A 29 USUÁRIOS</th>
                  <th className="right_radius">A PARTIR DE 30 USUÁRIOS</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                  <td className="col_table text_left_padding">CONSULTA DE URGÊNCIA E EMERGÊNCIA</td>
                  <td className="right_border background_td">24 HORAS</td>
                  <td className="background_td">24 HORAS</td>
                </tr>
                <tr>
                  <td className="col_table text_left_padding">CONSULTA INICIAL, RADIOLOGIA,<br/>
                                   ATENDIMENTOS PARA PREVENÇÃO,<br/>
                                   ODONTOPEDIATRIA E DENTÍSTICA CLÍNICA<br/>
                  </td>
                  <td className="right_border background_td" >30 DIAS</td>
                  <td className="background_td" >24 HORAS</td>
                </tr>
                <tr>
                  <td className="col_table text_left_padding">PROCEDIMENTOS EM PERIODONTIA</td>
                  <td className="right_border background_td" >60 DIAS</td>
                  <td className="background_td" >24 HORAS</td>
                </tr>
                <tr>
                  <td className="col_table text_left_padding">ENDODONTIA E CIRURGIA</td>
                  <td className="right_border background_td">120 DIAS</td>
                  <td className="background_td bottom_radius">24 HORAS</td>
                </tr>
            </tbody>
          </table>
        </Container>
        <div className="margin_container">
          <Row>
            <Col xs="12" sm="12" md="12" lg="12" xl="6">
              <div className="team_text team_margin">A MELHOR EQUIPE</div>
              <div className="team_text" style={{marginTop:-20}}>ESTÁ ESPERANDO</div>
              <div className="team_text" style={{marginTop:-20}}>PARA ATENDER VOCÊ</div>
              <div className="button_team"><span>NEGOCIE COM A GENTE</span></div>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="6">
              <div className="team_img">
                {''}
              </div>
            </Col>
          </Row>
        </div>
        <hr className="hr_style_company2"/>
      </div>
    );
  }
}
export default PlansCompany;



/** WEBPACK FOOTER **
 ** ./src/components/ForYourCompanyNew/PlansCompany.js
 **/